module.exports = __webpack_public_path__ + "static/208decc2b80a068fbe479242139e434d8278b54f1ef6385b95d00df402a2c487-416f9163c68d91e6dac32ffe3b912f37.jpeg";